module.exports = __webpack_public_path__ + "img/envelope.6b2dd0b7.svg";